import { useEffect } from 'react';
import { Box, Container, Stack, Typography, Button } from '@mui/material';
import PlusIcon from '@heroicons/react/24/solid/PlusIcon';
import { DashboardLayout } from 'layouts/dashboard/DashboardLayout';
import CollectionTable from 'pages/dashboard/sections/collections/CollectionTable';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCollections } from 'store/actions/collectionActions';

const CollectionHome = () => {
  const dispatch = useDispatch();
  const { collections } = useSelector((state: any) => state.collection);

  useEffect(() => {
    dispatch({ type: fetchCollections.request });
  }, [dispatch]);

  return (
    <DashboardLayout>
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth='lg'>
          <Stack spacing={3}>
            <Stack direction='row' spacing={3}>
              <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
                <Typography variant='h4'>Collections</Typography>
              </Stack>
              <div>
                <Button
                  startIcon={<PlusIcon fontSize='var(--icon-fontSize-md)' />}
                  variant='contained'
                >
                  Add
                </Button>
              </div>
            </Stack>
            <CollectionTable count={2} page={5} rows={collections} rowsPerPage={2} />
          </Stack>
        </Container>
      </Box>
    </DashboardLayout>
  );
};

export default CollectionHome;
